import { useEffect, useState } from 'react';
import calApi from '../api/calApi';
import { logBookingError } from '../loggingUtils';
import { CalEventData } from '../types';

const useCalEventData = ({
    teamId,
    organizationId,
    eventSlug,
}: {
    teamId: number;
    organizationId: number;
    eventSlug: string;
}) => {
    const [calEventData, setCalEventData] = useState<CalEventData | null>(null);

    useEffect(() => {
        if (teamId && organizationId && eventSlug) {
            calApi
                .getTeamEventType({
                    orgId: organizationId,
                    eventSlug,
                    teamId,
                })
                .then(setCalEventData)
                .catch((err) => {
                    logBookingError('Failed to get cal event type by slug', {
                        errorMessage: err.message,
                        additionalInfoToLog: {
                            teamId,
                            organizationId,
                            eventSlug,
                        },
                    });
                });
        }
    }, [teamId, organizationId, eventSlug]);

    return {
        calEventData,
    };
};

export default useCalEventData;
